import { render, staticRenderFns } from "./ModalNotas.vue?vue&type=template&id=3e2abb8a&scoped=true&"
import script from "./ModalNotas.vue?vue&type=script&lang=js&"
export * from "./ModalNotas.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotas.vue?vue&type=style&index=0&id=3e2abb8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2abb8a",
  null
  
)

export default component.exports